NtechApp.Intro = function($view, $introBottomSpacer) { //return;
    var me = this;

    this._$view = null;
    this._$introBottomSpacer = null;

    this._$slideshowNextButton = null;
    this._$slideshowPrevButton = null;

    this._$slideshowGrid = null;
    this._$slidesNavGrid = null;

    this._touchClickEvent = null;

    this._slideshowGridTabsCount = null;
    this._currentSlideshowGridTab = 0;
    //this._slideshowGridFilterNames = [];
    //this._currentSlideshowGridFilter = 0;
    this._showNextSlideshowGridItemTimeout = null;
    this._isFirstSlideshowGridItemShow = true;

    this._slideshowGrid = null;

    this._slidesNavGrid = null;

    this._lastResizeDocumentWidth = null;

    this._css = {
        ids: {
            intro: "intro"
        },

        classes: {
            slideshowNextButton: "nextButtonWrapper",
            slideshowPrevButton: "prevButtonWrapper",

            slideshowButtonWrapper: "slideshowButtonWrapper",
            slideshowButton: "button",
            slideshowButtonActive: "active",
            slideshowButtonAfterActive: "afterActive",

            slideshowGrid: "slideshowGrid",
            slideshowGridItem: "gridItem",
            slideshowSlideContent: "slideContent",
            
            slidesNavGrid: "slidesNavGrid",
            slidesNavGridItem: "navItem"
        },

        data: {
            slideshowGridItemFilterName: "data-grid-item-filter-name",
            slidesNavGridItemPos: "data-slides-nav-grid-item-pos"
        }
    }

    this._construct = function () {
        me._$view = $view;
        me._$introBottomSpacer = $introBottomSpacer;

        me._$slideshowNextButton = me._$view.find("." + me._css.classes.slideshowNextButton);
        me._$slideshowPrevButton = me._$view.find("." + me._css.classes.slideshowPrevButton);

        me._$slideshowGrid = me._$view.find("." + me._css.classes.slideshowGrid);
        me._$slidesNavGrid = me._$view.find("." + me._css.classes.slidesNavGrid);

        //me._$slideshowGrid.addClass("active");

        me._touchClickEvent = new NtechApp.TouchClickEvent();

        me._bindEvents();

        //me._updateIntroHeight();
        //me._centrifySlidesContent();
        me._createSlideshowGrid();

        me._lastResizeDocumentWidth = $(document).width();
    }

    this._bindEvents = function () {
        $(window).on(NtechApp.Intro.EVENT_WINDOW_RESIZE, function() {
            if(!me._wasWindowResized())
                return;

            setTimeout(function() {
                //me._updateIntroHeight();
                //me._centrifySlidesContent();
            }, 100);
        });

        $(document).on(NtechApp.Intro.EVENT_DOCUMENT_SCROLL, function() {
            //me._updateIntroHeight();
        });

        $(me).on(NtechApp.Intro.EVENT_SLIDESHOW_GRID_ITEM_SHOW, function() {
            if(!me._isFirstSlideshowGridItemShow)
                return;

            me._isFirstSlideshowGridItemShow = false;
            me._createSlidesNavGrid();
            me._scheduleNextSlideshowGridItemShow();
        });

        me._touchClickEvent.listen(me._$slidesNavGrid, "." + me._css.classes.slidesNavGridItem, function(event) {
            me._selectSlidesNavTab($(event.target));
        });

        me._touchClickEvent.listen(me._$slideshowNextButton, function() {
            me._unscheduleNextSlideshowGridItemShow();
            me._showNextSlideshowTab();
        });

        me._touchClickEvent.listen(me._$slideshowPrevButton, function() {
            me._unscheduleNextSlideshowGridItemShow();
            me._showPrevSlideshowTab();
        });

        me._$view.on("mouseleave.NtechApp.Intro", function() {
            var $buttons = me._$view.find("." + me._css.classes.slideshowButtonWrapper).find("." + me._css.classes.slideshowButton);
            $buttons.removeClass(me._css.classes.slideshowButtonActive).removeClass(me._css.classes.slideshowButtonAfterActive);
        });

        me._$view.on("mouseenter.NtechApp.Intro", "." + me._css.classes.slideshowButtonWrapper, function() {
            var $buttons = me._$view.find("." + me._css.classes.slideshowButtonWrapper).find("." + me._css.classes.slideshowButton);
            $buttons.removeClass(me._css.classes.slideshowButtonAfterActive).addClass(me._css.classes.slideshowButtonActive);
        });

        me._$view.on("mouseleave.NtechApp.Intro", "." + me._css.classes.slideshowButtonWrapper, function() {
            var $buttons = me._$view.find("." + me._css.classes.slideshowButtonWrapper).find("." + me._css.classes.slideshowButton);
            $buttons.removeClass(me._css.classes.slideshowButtonActive).addClass(me._css.classes.slideshowButtonAfterActive);
        });
    }

    this._unbindEvents = function () {
        $(window).off(NtechApp.Intro.EVENT_WINDOW_RESIZE);
        $(document).off(NtechApp.Intro.EVENT_DOCUMENT_SCROLL);
        $(me).off(NtechApp.Intro.EVENT_SLIDESHOW_GRID_ITEM_SHOW);
        me._touchClickEvent.unlisten(me._$slidesNavGrid);
        me._touchClickEvent.unlisten(me._$slideshowNextButton);
        me._touchClickEvent.unlisten(me._$slideshowPrevButton);
        me._$view.off("mouseleave.NtechApp.Intro");
        me._$view.off("mouseenter.NtechApp.Intro");
        me._slidesNavGrid.destruct();
        me._slideshowGrid.destruct();
    }

    this.destruct = function () {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.Intro.EVENT_WINDOW_RESIZE = "resize.NtechApp.Intro";
NtechApp.Intro.EVENT_DOCUMENT_SCROLL = "scroll.NtechApp.Intro";

NtechApp.Intro.EVENT_SLIDESHOW_GRID_ITEM_SHOW = "slideshowGridItemShow.NtechApp.Intro";

NtechApp.Intro.NAVIGATION_MENU_PX_OFFSET = 120;
NtechApp.Intro.INTRO_BOTTOM_SPACER_PT_HEIGHT = 3;

NtechApp.Intro.prototype._hasTouchEvents = function() {
    return Modernizr.touch;
};

NtechApp.Intro.prototype._wasWindowResized = function() {
    if(!this._hasTouchEvents())
        return true;

    if($(document).width() != this._lastResizeDocumentWidth)
        var wasResized = true;
    else
        var wasResized = false;

    this._lastResizeDocumentWidth = $(document).width();
    return wasResized;
};

NtechApp.Intro.prototype._updateIntroHeight = function() {
    var spacerPxHeight = $(window).width() * NtechApp.Intro.INTRO_BOTTOM_SPACER_PT_HEIGHT / 100;

    this._$view.height($(window).height() - NtechApp.Intro.NAVIGATION_MENU_PX_OFFSET - spacerPxHeight);
    this._$slideshowGrid.height($(window).height() - NtechApp.Intro.NAVIGATION_MENU_PX_OFFSET - spacerPxHeight);
    this._$introBottomSpacer.height(spacerPxHeight);
};

NtechApp.Intro.prototype._centrifySlidesContent = function() {
    var me = this;

    $.each(this._$slideshowGrid.find("." + this._css.classes.slideshowSlideContent), function() {
        if($(this).css("display") != "block")
            return;

        var top = (me._$view.height() / 2) - ($(this).outerHeight() / 2);
        $(this).css("top", top + "px");
    });
};

//NtechApp.Intro.prototype._createSlideshowGridFilters = function() {
//    var me = this;
//
//    var $gridItems = this._$slideshowGrid.find("." + this._css.classes.slideshowGridItem);
//    var slideshowGridFilters = {};
//
//    var i = 0;
//    var initialFilter = null;
//
//    $.each($gridItems, function() {
//        var filterName = "filter" + ++i;
//        if(initialFilter == null)
//            initialFilter = filterName;
//
//        me._slideshowGridFilterNames.push(filterName);
//
//        $(this).attr(me._css.data.slideshowGridItemFilterName, filterName);
//        slideshowGridFilters[filterName] = function(item) {
//            return $(item).attr(me._css.data.slideshowGridItemFilterName) == filterName;
//        }
//    });
//
//    slideshowGridFilters.initial = initialFilter;
//
//    return slideshowGridFilters;
//};

NtechApp.Intro.prototype._createSlideshowGrid = function() {
    var me = this;
    //var slideshowGridFilters = this._createSlideshowGridFilters();

    //this._slideshowGrid = new Gridifier(this._$slideshowGrid, {
    //    class: this._css.classes.slideshowGridItem,
    //    filter: slideshowGridFilters,
    //    toggle: "fade",
    //    toggleDuration: 600,
    //    gridTransformTimeout: 0,
    //});
    //
    //this._slideshowGrid.onGridSizesChange(function() {
    //    if(!me._wasWindowResized())
    //        return;
    //
    //    me._updateIntroHeight();
    //});
    //
    //this._slideshowGrid.onShow(function() {
    //    me._slideshowGrid.setToggleAnimationMsDuration(1200);
    //    $(me).trigger(NtechApp.Intro.EVENT_SLIDESHOW_GRID_ITEM_SHOW);
    //});
    //
    //me._slideshowGrid.append(me._slideshowGrid.collectNew());

    // Always show arrows on touch devices
    if(($("html").hasClass("touch")))
        this._$view.find(".slideshowButtonWrapper .button").addClass("forceActive");

    this._slideshowGrid = new NtechApp.Slider(this._$slideshowGrid, this._css.classes.slideshowGridItem, 1000);
    $(this).trigger(NtechApp.Intro.EVENT_SLIDESHOW_GRID_ITEM_SHOW);
};

NtechApp.Intro.prototype._createSlidesNavGrid = function() {
    // this._slidesNavGrid = new Gridifier(this._$slidesNavGrid, {
    //     class: this._css.classes.slidesNavGridItem
    // });

    //var items = this._slidesNavGrid.collectNew();
    //this._slidesNavGrid.append(items);
    //this._slideshowGridTabsCount = items.length;
    var $items = this._$slidesNavGrid.find("." + this._css.classes.slidesNavGridItem);
    this._slideshowGridTabsCount = $items.length;

    $items.css({
        position: "static",
        left: "auto",
        top: "auto",
        visibility: "visible"
    });
};

NtechApp.Intro.prototype._selectSlidesNavTab = function($slideTab) {
    var tabPos = parseInt($slideTab.attr(this._css.data.slidesNavGridItemPos), 10);
    //var linkedFilterName = this._slideshowGridFilterNames[tabPos - 1];

    this._unscheduleNextSlideshowGridItemShow();
    this._showSlideshowTab(tabPos - 1);
};

NtechApp.Intro.prototype._highlightSlidesNavTab = function(tabPos) {
    var me = this;
    var $slideTab = null;

    $.each(this._$slidesNavGrid.find("." + this._css.classes.slidesNavGridItem), function() {
        $(this).removeClass("active");
        if(parseInt($(this).attr(me._css.data.slidesNavGridItemPos), 10) == tabPos)
            $slideTab = $(this);
    });

    $slideTab.addClass("active");
};

NtechApp.Intro.prototype._unscheduleNextSlideshowGridItemShow = function() {
    if(this._showNextSlideshowGridItemTimeout != null) {
        clearTimeout(this._showNextSlideshowGridItemTimeout);
        this._showNextSlideshowGridItemTimeout = null;
    }
};

NtechApp.Intro.prototype._scheduleNextSlideshowGridItemShow = function() {
    var me = this;
    this._showNextSlideshowGridItemTimeout = setTimeout(function() {
        me._showNextSlideshowTab.call(me);
    }, 4000);
};

NtechApp.Intro.prototype._showNextSlideshowTab = function() {
    //this._currentSlideshowGridFilter++;
    //if(this._currentSlideshowGridFilter >= this._slideshowGridFilterNames.length)
    //    this._currentSlideshowGridFilter = 0;
    this._currentSlideshowGridTab++;
    if(this._currentSlideshowGridTab >= this._slideshowGridTabsCount)
        this._currentSlideshowGridTab = 0;

    this._showSlideshowTab(this._currentSlideshowGridTab);
};

NtechApp.Intro.prototype._showPrevSlideshowTab = function() {
    //this._currentSlideshowGridFilter--;
    //if(this._currentSlideshowGridFilter < 0)
    //    this._currentSlideshowGridFilter = this._slideshowGridFilterNames.length - 1;
    this._currentSlideshowGridTab--;
    if(this._currentSlideshowGridTab < 0)
        this._currentSlideshowGridTab = this._slideshowGridTabsCount - 1;

    this._showSlideshowTab(this._currentSlideshowGridTab);
};

NtechApp.Intro.prototype._showSlideshowTab = function(tabIndex) {
    this._currentSlideshowGridTab = tabIndex;
    this._highlightSlidesNavTab(tabIndex + 1);
    this._slideshowGrid.slideTo(tabIndex);
    //this._slideshowGrid.setFilter(this._slideshowGridFilterNames[tabIndex]);
    this._scheduleNextSlideshowGridItemShow();
};